<script setup>
import { computed, getCurrentInstance } from 'vue';
import ComponentSettingsBtn from './component-settings/ComponentSettingsBtn';
import ComponentFieldsBtn from './component-fields/ComponentFieldsBtn';

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const route = proxy.$route;

// --- Computed ---

const routeName = computed(() => {
    return route.name;
});

const component = computed(() => {
    return store.state.componentRoot.component;
});

const tableName = computed(() => {
    return route.params.component;
});

const show = computed(() => {
    // Currently hardcoded to true in original, preserving that logic
    return true;

    /* Settings should not be available to forms, so there's no need for the button group
       return component.value?.navigationGroup !== 'Forms';
    */
});
</script>

<template>
    <div v-if="show" class="d-flex align-items-center">
        <ComponentSettingsBtn
            v-if="tableName"
            :class="{ 'active': routeName === 'componentSettings' }"
            :table-name="tableName"
            class="me-1"
        />

        <ComponentFieldsBtn
            v-if="tableName"
            :class="{ 'active': routeName === 'componentFields' }"
            :table-name="tableName"
        />
    </div>
</template>

<style scoped>
/* Scoped styles preserved */
.active {
    /* Assuming some active styling was intended here */
    background-color: var(--bs-light);
    border-color: var(--bs-gray-400);
}
</style>